<template>
<div>
  <el-tabs v-model="card_index">
    <el-tab-pane label="全部" name="all">
      <LitigationTabAll v-if="card_index==='all'" />
    </el-tab-pane>
    <el-tab-pane label="待审核" name="list">
      <LitigationTab1 v-if="card_index==='list'" />
    </el-tab-pane>
    <el-tab-pane label="审核中" name="shz">

      <LitigationTab5 v-if="card_index==='shz'" />
    </el-tab-pane>
    <el-tab-pane label="已审核" name="ys">
      <LitigationTab2 v-if="card_index==='ys'" />
    </el-tab-pane>
    <el-tab-pane label="驳回" name="bh">
      <LitigationTab3 v-if="card_index==='bh'" />
    </el-tab-pane>
  </el-tabs>
</div>
</template>

<script>
import LitigationTab5 from "./LitigationTab5";
import LitigationTab2 from "./LitigationTab2";
import LitigationTab3 from "./LitigationTab3";
import LitigationTab1 from "./LitigationTab1";
import LitigationTabAll from "./LitigationTabAll";

export default {
  name: "LitigationListLayout",
  components: {LitigationTabAll, LitigationTab5, LitigationTab2, LitigationTab3, LitigationTab1},
  data(){
    return{
      card_index:"list"
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/litigation/LitigationListLayout.vue